import axios from "axios";

export default {
    get(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/wallet/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllTransactions(currentPage = 0, pageSize = 10, id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/wallet/" +
                id +
                "/transactions?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payCash(id, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE + "auth/wallet/" + id + "/pay/cash",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payPaypal(walletId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/wallet/" +
                walletId +
                "/pay/paypal",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payStripe(walletId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/wallet/" +
                walletId +
                "/pay/stripe",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    paySuccess(paymentPlataformId, walletId, mode, token, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/wallet/" +
                walletId +
                "/pay/success/" +
                mode +
                "/" +
                token +
                "/" +
                paymentPlataformId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payCancel(paymentPlataformId, walletId, mode, token, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/wallet/" +
                walletId +
                "/pay/cancel/" +
                mode +
                "/" +
                token +
                "/" +
                paymentPlataformId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
};
